// ══════════════════════════════════════════════
//  Translations ENGLISH — Elghali Car
// ══════════════════════════════════════════════
const en = {

  nav: {
    home:      'Home',
    cars:      'Cars',
    contact:   'Contact',
    admin:     'Admin',
    langLabel: 'FR',
    langFull:  'Français',
  },

  footer: {
    desc:    'Car rental in Marrakech & all Morocco. Airport delivery, instant WhatsApp booking, full insurance included.',
    nav:     'Navigation',
    contact: 'Contact',
    rights:  'All rights reserved.',
    privacy: 'Privacy Policy',
    terms:   'Terms & Conditions',
    hours:   '7 days · 24/7',
  },

  home: {
    badge:      'Car Rental Morocco — Marrakech',
    heroTitle1: 'Rent a Car in',
    heroGold:   'Marrakech',
    heroSub:    'Airport delivery, hotel pickup, WhatsApp booking. Serving all Morocco — Casablanca, Agadir, Rabat & every airport. Insurance included.',
    ctaCars:    'Browse vehicles',
    ctaContact: 'Book on WhatsApp',
    scrollLabel:'Scroll',

    stats: {
      vehicles: 'Vehicles',
      clients:  'Happy clients',
      rating:   'Star rating',
      years:    'Years experience',
    },

    whyUs:    'Why choose Elghali Car',
    whyTitle: 'Fast, affordable & delivered to you',

    features: [
      { title: 'WhatsApp Booking',    desc: 'Book in seconds via WhatsApp, 7 days a week, 24 hours a day. Instant confirmation.' },
      { title: 'Insurance included',  desc: 'All vehicles include comprehensive insurance. All-inclusive price, no hidden fees.' },
      { title: 'Recent fleet 2020–24',desc: 'Carefully maintained vehicles, clean and inspected before every rental.' },
      { title: 'Airport delivery',    desc: 'Delivery to Marrakech Menara Airport and any city across Morocco.' },
    ],

    fleetLabel:  'Our fleet',
    fleetTitle:  'Car Rental Marrakech — All Vehicles',
    fleetSub:    'Economy, SUVs, sedans and 4x4s — a car for every journey.',
    seeAll:      'See all →',
    loading:     'Loading vehicles...',
    noVehicles:  'No vehicles available right now.',
    noVehiclesSub: 'Contact us on WhatsApp to check availability.',
    seeFleet:    'See entire fleet →',

    testimonials:     'Reviews',
    testimonialsTitle:'What our clients say',
    testimonialsList: [
      { name: 'Sophie M.',  city: 'Paris, France',   text: 'Perfect airport pickup at Marrakech Menara! Clean car, fair price. Highly recommend Elghali Car for Morocco.' },
      { name: 'James T.',   city: 'London, UK',      text: 'Best car rental experience in Marrakech. Delivered to our riad in the medina. Will use again on our next Morocco trip!' },
      { name: 'Carlos R.',  city: 'Madrid, Spain',   text: 'WhatsApp booking was super fast. Great service, excellent value. Perfect for exploring Morocco by car.' },
    ],

    ctaTitle1:    'Ready to explore',
    ctaGold:      'Morocco?',
    ctaSub:       'Message us on WhatsApp and get your car in minutes. Free delivery anywhere in Morocco.',
    ctaReserve:   '💬 Book on WhatsApp',
    ctaContactUs: 'View our fleet',
  },

  cars: {
    label:      'Our Fleet',
    title:      'Car Rental Marrakech — All Vehicles',
    found:      (n) => `${n} vehicle${n > 1 ? 's' : ''} found`,
    searchPlaceholder: 'Search by brand or model...',
    allCategories: 'All',
    allStatus:   'All statuses',
    available:   '✓ Available',
    unavailable: '✗ Unavailable',
    reset:       '✕ Reset',
    loading:     'Loading vehicles...',
    noResults:   'No vehicles found',
    noResultsSub:'Try modifying your search criteria.',
    resetFilters:'Reset filters',
    sort: {
      default:    'Default',
      price_asc:  'Price: low to high',
      price_desc: 'Price: high to low',
      year_desc:  'Most recent',
    },
  },

  detail: {
    breadHome:       'Home',
    breadCars:       'Cars',
    available:       '✓ Available',
    unavailable:     '✗ Unavailable',
    pricePerDay:     'Price / day',
    tariff:          'Rental rate',
    madPerDay:       'MAD / day',
    fuel:            'Fuel',
    transmission:    'Transmission',
    seats:           'Seats',
    year:            'Year',
    description:     'Description',
    priceCalc:       '💡 Price Calculator',
    days:            'days',
    bookedPeriods:   'Already booked periods:',
    confirmed:       'Confirmed',
    pending:         'Pending',
    reserveBtn:      '🗓️ Reserve this Vehicle',
    notAvailable:    '❌ Vehicle unavailable',
    notAvailableSub: 'Browse our other available vehicles.',
    backBtn:         '← View all vehicles',
    notFound:        'Vehicle not found.',
    loading:         'Loading...',
    modalTitle:      'Book',
    clientInfo:      '👤 Client Information',
    fullName:        'Full name *',
    fullNamePH:      'John Smith',
    email:           'Email *',
    phone:           'Phone',
    phonePH:         '+44 7 00 00 00 00',
    period:          '📅 Rental Period',
    startDate:       'Start date *',
    endDate:         'End date *',
    totalEst:        '💰 Estimated Total',
    duration:        (n) => `${n} day${n > 1 ? 's' : ''} rental`,
    from:            'From',
    to:              'to',
    notes:           'Notes (optional)',
    notesPH:         'Special requests, delivery location...',
    confirm:         '✅ Confirm booking',
    cancel:          'Cancel',
    checking:        '⏳ Checking...',
    clickStart:      '👆 Click a date to set the start',
    clickEnd:        '👆 Click an end date',
    legendSelected:  'Selected',
    legendBooked:    'Already booked',
    legendRange:     'Chosen period',
    successMsg:      (price, days) => `Booking confirmed! Total: ${price} MAD for ${days} days.`,
  },

  contact: {
    label:       'Get in touch',
    title:       'Car Rental Marrakech — Contact Us',
    subtitle:    'Book Your Car in Minutes',
    desc:        'Available 7 days a week, 24/7. WhatsApp booking, airport delivery at Marrakech Menara and all across Morocco.',
    address:     'Address',
    addressVal:  'Marrakech Mabrouka, 40000 Marrakech, Morocco',
    phone:       'Phone / WhatsApp',
    email:       'Email',
    hours:       'Availability',
    hoursVal:    '7 days a week · 24 hours a day',
    whyLabel:    'Why contact us?',
    whyItems:    ['🗓️ Instant WhatsApp booking', '✈️ Marrakech Airport delivery', '🚗 Free quote in minutes', '🇬🇧 English-speaking team'],
    formTitle:   '📨 Send us a Message',
    fullName:    'Full Name *',
    fullNamePH:  'John Smith',
    emailField:  'Email *',
    phoneField:  'Phone',
    phonePH:     '+44 7 00 00 00 00',
    subject:     'Subject',
    subjectPH:   '— Choose a subject —',
    message:     'Message *',
    messagePH:   'Desired dates, vehicle type, delivery location...',
    send:        '📨 Send Message',
    sending:     '⏳ Sending...',
    successTitle:'Message Sent!',
    successMsg:  (name, email) => `Thank you ${name}! We will reply very quickly to ${email}.`,
    sendAnother: '✉️ Send another message',
    subjects: [
      { value: 'reservation', label: '🗓️ Booking request' },
      { value: 'devis',       label: '💰 Quote request' },
      { value: 'airport',     label: '✈️ Airport delivery' },
      { value: 'info',        label: '📋 General information' },
      { value: 'autre',       label: '💬 Other' },
    ],
  },

  notFound: {
    title: 'Page not found',
    desc:  'The page you are looking for does not exist or has been moved.',
    back:  '← Go back',
    home:  '🏠 Home',
  },

  card: {
    reserve:     'Book →',
    unavailable: 'Unavailable',
    perDay:      '/day',
    seats:       'seats',
  },

  months: ['January','February','March','April','May','June','July','August','September','October','November','December'],
  days:   ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
};

export default en;
